<template >
	<div class="employeeAutoComplete">
		<!-- :filter="customFilter" -->
	<v-autocomplete 
		v-model="select"
		autocomplete	
		autofocus	
		ref="autocomplete"
		:label=label		
		:items="items"
		@change="returnSelection"
		clearable
		:prepend-icon="prepend"
		:flat="flat"
		hide-no-data
		hide-details		
		:solo-inverted="soloinverted"
		:outline="outline"
		solo
		return-object
		:single-line="singleline"
		:filter="customFilter"
		v-on:change="changeHandler"
	>
		<template slot="item" slot-scope="{ item, tile }">
	        <v-list-tile-avatar dark tile color="grey darken-3" class="smallerAvatar" style="color: white; ">
	        	{{item.id}}
	        </v-list-tile-avatar>
	        <v-list-tile-content>
		        <v-list-tile-title>
		          	{{item.name}}
		        </v-list-tile-title>
	        </v-list-tile-content>
	    </template>
	    <template slot="selection" slot-scope="{ item, tile }">
	        <v-list-tile-content>
		        <v-list-tile-title>
		          	{{item.name}}
		        </v-list-tile-title>
	        </v-list-tile-content>
	    </template>
	</v-autocomplete>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
	data: () => ({
		loading: false,
		select: null,
	}),

	props: {
    	singleline: Boolean,
    	soloinverted: Boolean,
    	solo: Boolean,
    	outline: Boolean,
    	flat: { type: Boolean, default: true },
    	prepend: String,
    	label: {type: String, default: "Colleges" },
    	changeHandler: Function, 
    },

     watch: {
		// This was put in to allow routing on RoomViewer.  The roomviewer component sets this sync which is watched.
		async collegeSync (val) { 
			this.select = val
		}
	},

    computed: {
			...mapState({ 	items: 		state => state.lists.colleges, 
							collegeSync: 	state => state.roomViewer.collegeSync,
			}),
	},

	methods: {
		returnSelection: function (value) {
			this.$emit('return-selection', value)	
		},	

		customFilter (item, queryText, itemText) {
	        const searchText = queryText.toLowerCase()
        	return item.id.indexOf(searchText) > -1 	||
          	    item.nameandid.toLowerCase().indexOf(searchText) > -1  
	    },
	}
}

</script>

<style>
.v-list__tile--highlighted {
	height: 70px;
}

.smallerAvatar .v-avatar--tile {
	font-size: 10pt !important;
}

</style>




// WEBPACK FOOTER //
// src/components/forms/AutocompleteCollege.vue